import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { motion } from 'framer-motion';
import { Lock, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

export const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token'); // URL'den token'ı alır
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error('Invalid or missing reset token.');
    if (newPassword.length < 6) return toast.error('Password must be at least 6 characters.');
    if (newPassword !== confirmPassword) return toast.error('Passwords do not match.');

    setLoading(true);
    try {
      const res = await axios.post(`${BACKEND_URL}/api/auth/reset-password`, { 
        token, 
        new_password: newPassword 
      });
      toast.success(res.data.message);
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to reset password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0E0F11] flex items-center justify-center px-4 py-20">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md relative z-10">
        
        <div className="bg-[#1A1D20] rounded-2xl p-8 border border-[#2A2D31] shadow-2xl">
          <div className="text-center mb-8">
            <div className="w-16 h-16 rounded-xl bg-gradient-to-r from-[#16A34A] to-[#15913f] flex items-center justify-center mx-auto mb-4 shadow-lg shadow-[#16A34A]/30">
              <span className="text-3xl">🔐</span>
            </div>
            <h1 className="font-heading font-bold text-2xl text-white uppercase tracking-wide mb-2">Create New Password</h1>
            <p className="font-body text-sm text-zinc-400">Please enter your new strong password.</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label className="font-body text-sm text-zinc-300">New Password</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-500" />
                <Input type="password" placeholder="••••••••" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="pl-11 bg-[#15171a] border-[#2A2D31] text-white h-12" />
              </div>
            </div>
            <div className="space-y-2">
              <Label className="font-body text-sm text-zinc-300">Confirm New Password</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-500" />
                <Input type="password" placeholder="••••••••" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="pl-11 bg-[#15171a] border-[#2A2D31] text-white h-12" />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-gradient-to-r from-[#16A34A] to-[#15913f] text-white h-12 font-bold uppercase">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Update Password'}
            </Button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};